import Logger from "../lib/logger";

export const sendLog = (
  eventName,
  { page, action, reportName = "", merchantName = "" } = {},
  extra = {}
) => {
  const pageName = page.startsWith("/") ? page.slice(1) : page;
  Logger.log(eventName, {
    page: pageName,
    action,
    ...(reportName && { reportName }),
    ...(merchantName && { merchantName }),
    ...extra,
  });
};
